<template>
    <div v-if="state && state.items.length" class="feature-filters">
        <span class="features-label">Features:</span>

        <ul class="feature-filters__filters">
            <li v-for="item in state.items" :key="item.value" class="feature-filters__filter">
                <label class="ais-ToggleRefinement-label">
                    <input type="checkbox" class="ais-ToggleRefinement-checkbox" :checked="item.isRefined" @change="state.refine(item.value)">
                    <div class="ais-ToggleRefinement-labelText">{{ item.label }}</div>
                </label>
            </li>
        </ul>
    </div>
</template>
<script>
import { createWidgetMixin } from 'vue-instantsearch';
import { connectRefinementList } from 'instantsearch.js/es/connectors';

export default {
    name: 'AlgoliaFeatureFilters',
    mixins: [
        createWidgetMixin({ connector: connectRefinementList })
    ],

    props: {
        attribute: {
            type: String,
            required: true
        }
    },

    computed: {
    	widgetParams() {
      		return {
                attribute: this.attribute,
                transformItems: (items) => {
                    const order = ['Family Friendly', 'Pet Friendly', 'Accessible'];
                    return items ? items.sort((a, b) => order.indexOf(a.label) > order.indexOf(b.label) ? 1 : -1) : [];
                },
			  }
		}
    },
}
</script>
<style lang="scss" scoped>
    .feature-filters {
        display: flex;
        align-items: flex-start;
        padding: 30px 0;
        overflow: auto;

        @include media-query(tiny) {
            flex-direction: column;
        }
    }

    .feature-filters__filters {
        display: flex;
        align-items: center;
        flex: 1;
        flex-wrap: wrap;

        @include media-query(tiny) {
            flex-wrap: nowrap;
            flex-direction: column;
            align-items: flex-start;
            padding-left: 10px;
        }
    }

    .feature-filters__filter {
        margin-right: getSpacing('base');
    }

    .features-label {
        display: inline-block;
        flex-shrink: 0;
        font-size: 16px;
        font-weight: 600;
        color: getColour("grey", "dark");
        padding: 10px;
        margin-right: 12px;

        @include media-query(lap) {
            font-size: 14px;
            margin-right: 12px;
        }
    }

    .ais-ToggleRefinement-label {
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .ais-ToggleRefinement-checkbox {
        appearance: none;
        cursor: pointer;
        display: inline-block;
        width: 24px;
        height: 24px;
        margin: 0;
        border: 2px solid getColor("sand", "base");
        border-radius: 0;
        background-repeat: no-repeat;
        background-position: center;
        background-size: contain;
        transition: all .3s;

        &:checked {
            border-color: getColor("blue", "charcoal");
            background-image: url('../assets/images/tick.svg');
        }
    }

    .ais-ToggleRefinement-labelText {
        display: flex;
        font-size: 16px;
        font-weight: 400;
        color: getColour("grey", "dark");
        padding: 10px;
        cursor: pointer;
    }

    ::v-deep .ais-ToggleRefinement-count {
        display: none;
    }
</style>